import { Toast } from 'react-vant';
import { createOrder } from '../api';
import { _T } from '@dana/components';

export type CardData = {
  add: string;
  price: string;
  total: string;
  id: string;
};

const card: React.FC<{
  data: CardData;
  index: number;
  uid: string;
  isShowUser: boolean;
  country: string;
}> = ({ data, index, uid, isShowUser, country }) => {
  const handleCreateOrder = async (id: string) => {
    if (!isShowUser) {
      Toast.fail(_T('请输入正确的用户ID'));
      // Toast.fail(_T('Failed to confirm user ID'))
      return;
    }
    if (!uid || uid === 'undefined') {
      Toast.fail(_T('请输入用户ID'));
      // Toast.fail(_T('Please enter user ID'))
      return;
    }
    const res = await createOrder({
      uid,
      goodsId: id,
      // goodsId: '2423423142134',
      goodsType: 1,
      subject: 'order',
      country,
      currency: 'USD',
      // price: Number(data.price)
    });
    if (res) {
      window.location.href = res;
    }
  };

  return (
    <div
      className="relative w-[111px] h-[84px] bg-[#F2F2F2] rounded-[10px] flex justify-center items-center flex-col pt-[14px] mt-[9px]"
      onClick={() => handleCreateOrder(data.id)}
      style={{
        marginLeft: index % 3 === 0 ? '0px' : '9px',
      }}
    >
      <div
        className="absolute right-0 top-0 w-[73px] h-[18px] rounded-tr-[8px] rounded-bl-[8px] bg-[#1AD4A8] text-white
            font-semibold text-[10px] leading-normal font-sans flex justify-center items-center whitespace-nowrap"
      >
        {data.add} {_T('Plus')}
      </div>
      <div className="flex justify-center items-center">
        <div
          className="w-[20px] h-[20px] bg-cover"
          style={{
            backgroundImage: `url(${require('../asset/imgs/coin.png')})`,
          }}
        ></div>
        <div className="text-[#3B3B3B] font-bold text-[14px] leading-normal font-sans ml-[3px]">
          {data.total}
        </div>
      </div>
      <div className="text-customGray font-sans text-base12 font-semibold leading-normal">
        ${data.price}
      </div>
    </div>
  );
};

export default card;
